export default "__VITE_PUBLIC_ASSET__19504452__"